/* Header & nav rebuild (10.29.26): open/close for the image dropdowns in snippets/pb-mega-nav.liquid.
   - Mouse: opens after a short pause so passing over the nav doesn't flash panels; switching
     between items while one is open is instant; closes shortly after the pointer leaves.
   - Touch: first tap on a top item opens its panel, second tap follows the link.
   - Keyboard: focusing a top item opens its panel, Tab moves through its cards, focus leaving
     the nav closes it, Escape closes and keeps focus on the top item.
   - Card images are lazy; the first time the pointer reaches the nav they are told to load. */
(function () {
  var nav = document.querySelector('.pb-nav');
  if (!nav) return;

  var items = nav.querySelectorAll('.pb-nav__item--mega');
  var openItem = null;
  var openTimer = null;
  var closeTimer = null;
  var OPEN_DELAY = 90;
  var CLOSE_DELAY = 160;
  var canHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;

  var header = nav.closest('.site-header');

  function setOpen(item) {
    if (openItem === item) return;
    // Solid bar while a panel is open, so the transparent homepage header doesn't show the hero through it.
    if (header) header.classList.toggle('pb-header--menu-open', !!item);
    if (openItem) {
      openItem.classList.remove('is-open');
      openItem.querySelector('.pb-nav__link').setAttribute('aria-expanded', 'false');
    }
    openItem = item;
    if (item) {
      item.classList.add('is-open');
      item.querySelector('.pb-nav__link').setAttribute('aria-expanded', 'true');
    }
  }

  function clearTimers() {
    clearTimeout(openTimer);
    clearTimeout(closeTimer);
  }

  var imagesPrimed = false;
  function primeImages() {
    if (imagesPrimed) return;
    imagesPrimed = true;
    var imgs = nav.querySelectorAll('.pb-card__img[loading="lazy"]');
    for (var i = 0; i < imgs.length; i++) imgs[i].setAttribute('loading', 'eager');
  }

  nav.addEventListener('mouseenter', primeImages);
  nav.addEventListener('focusin', primeImages);

  Array.prototype.forEach.call(items, function (item) {
    var link = item.querySelector('.pb-nav__link');

    item.addEventListener('mouseenter', function () {
      if (!canHover) return;
      clearTimers();
      if (openItem) {
        setOpen(item);
      } else {
        openTimer = setTimeout(function () { setOpen(item); }, OPEN_DELAY);
      }
    });

    item.addEventListener('mouseleave', function () {
      if (!canHover) return;
      clearTimers();
      closeTimer = setTimeout(function () { setOpen(null); }, CLOSE_DELAY);
    });

    item.addEventListener('focusin', function (evt) {
      // Only open on the top link itself; focus moving between this item's cards keeps it open.
      // Touch taps also focus the link, so on touch screens the click handler decides instead.
      if (!canHover) return;
      if (evt.target === link && openItem !== item) {
        clearTimers();
        setOpen(item);
      }
    });

    link.addEventListener('click', function (evt) {
      if (canHover) return;
      if (openItem !== item) {
        evt.preventDefault();
        primeImages();
        setOpen(item);
      }
    });
  });

  document.addEventListener('click', function (evt) {
    if (openItem && !nav.contains(evt.target)) setOpen(null);
  });

  nav.addEventListener('focusout', function (evt) {
    if (!evt.relatedTarget || !nav.contains(evt.relatedTarget)) setOpen(null);
  });

  document.addEventListener('keydown', function (evt) {
    if (evt.key !== 'Escape' || !openItem) return;
    var item = openItem;
    clearTimers();
    setOpen(null);
    if (item.contains(document.activeElement)) item.querySelector('.pb-nav__link').focus();
  });
})();
